import { useEffect, useRef } from 'react';

const CLASSNAME_HEADER = 'header--hidden';
const CLASSNAME_SECTION = 'pagesection__poll--sticky';

const useSetStickyProgBar = (hasLoaded: boolean) => {
  const queryRoot =
    document.querySelector(`[data-${process.env.REACT_APP_NAME}]`).shadowRoot ?? document;

  const fixedScrollPos = useRef(0);
  const hideableElementsHeight = useRef(0);

  const setStickyProgBar = () => {
    const progBarSection = queryRoot
      .querySelector('.progressbar__progress')
      ?.closest('.pagesection__poll') as HTMLElement;
    const header =
      (queryRoot.querySelector('.header') as HTMLElement) ||
      (document.querySelector('header') as HTMLElement);

    if (!hideableElementsHeight.current) {
      const hideableElements = queryRoot.querySelectorAll('.progressbar__hideonsticky');
      hideableElementsHeight.current = Array.from(hideableElements).reduce(
        (sum, element) => {
          return sum + (element as HTMLElement).offsetHeight;
        },
        0,
      );
    }

    if (!progBarSection || !header) return;

    const headerHeight = header.offsetHeight;
    const progBarTop = progBarSection.getBoundingClientRect().top;

    const areProgressDetailsReduced =
      progBarSection.classList.contains(CLASSNAME_SECTION);

    if (!fixedScrollPos.current) {
      if (progBarTop < headerHeight) {
        fixedScrollPos.current = window.scrollY;
        header.classList.add(CLASSNAME_HEADER);
      }
    }
    if (fixedScrollPos.current) {
      if (window.scrollY < fixedScrollPos.current && !areProgressDetailsReduced) {
        header.classList.remove(CLASSNAME_HEADER);
        fixedScrollPos.current = 0;
      }
      if (progBarTop < 10) {
        progBarSection.classList.add(CLASSNAME_SECTION);
      }
    }

    const isHideableBiggerThenHeader = hideableElementsHeight.current >= headerHeight;

    if (
      fixedScrollPos.current ||
      (isHideableBiggerThenHeader && areProgressDetailsReduced)
    )
      if (progBarTop > hideableElementsHeight.current + 5) {
        progBarSection.classList.remove(CLASSNAME_SECTION);
      }
  };

  useEffect(() => {
    if (!hasLoaded) return undefined;

    setTimeout(() => {
      window.scrollTo(0, 0);

      document.addEventListener('scroll', () => {
        setStickyProgBar();
      });
    }, 300);

    return () => {
      document.removeEventListener('scroll', () => {
        setStickyProgBar();
      });
    };
  }, [hasLoaded]);
};

export default useSetStickyProgBar;
